export default "__VITE_ASSET__31dba173__"